import TypoGraphy from '@/typography';
import React, { useState } from 'react';
import { projectImages } from '../../../public/Assets/Images';
import './index.scss';
import useViewType from '@/utils/Hooks/useViewType';
import { useParams } from 'next/navigation';
import { getSlugAndRouteName } from '@/utils/Functions';
interface PaginationProps {
  pageCount: number;
  pageNo: number;
  onPageChange: (page: number) => void;
}
const Pagination: React.FC<PaginationProps> = ({
  pageCount,
  pageNo,
  onPageChange
}) => {
  const isMobile = useViewType();
  const numbers = Array.from({
    length: pageCount
  }, (_, index) => index + 1);
  const params = useParams();
  const {
    isIndustry,
    isSubIndustry,
    isSingleCourse,
    slug
  } = getSlugAndRouteName(params?.route?.toString() || '');
  const handlePageChange = (page: number) => {
    if (page === active) return;
    window.scrollTo(0, 0);
    setactive(page);
    onPageChange(page); // Call the onPageChange function passed from parent
  };
  const [active, setactive] = useState(1);
  const getPaginationFrontImage = () => {
    if (pageNo === 1) {
      return <img src={projectImages.mobilepaginationdisabled} alt="left" loading='lazy' />;
    }
    return <img src={projectImages.mobilepaginationnormal} alt="left" loading='lazy' style={{
      transform: "rotate(180deg)"
    }} data-sentry-component="getPaginationFrontImage" data-sentry-source-file="index.tsx" />;
  };
  const getPaginationBackImage = () => {
    if (pageNo === numbers.length) {
      return <img src={projectImages.mobilepaginationdisabled} alt="right" loading='lazy' style={{
        transform: "rotate(180deg)"
      }} />;
    }
    return <img src={projectImages.mobilepaginationnormal} loading='lazy' alt="right" data-sentry-component="getPaginationBackImage" data-sentry-source-file="index.tsx" />;
  };
  if (!numbers?.length) return <></>;
  return <div className={(isIndustry || isSubIndustry) && isMobile ? "pagination_wrapper_mobile" : "pagination_wrapper"} data-sentry-component="Pagination" data-sentry-source-file="index.tsx">
      {isMobile ? <div onClick={() => handlePageChange(pageNo > 1 ? pageNo - 1 : pageNo)}> {getPaginationFrontImage()} </div> : <div className={pageNo === 1 ? "disabled_button" : "previous_button pagination_b"} onClick={() => handlePageChange(pageNo > 1 ? pageNo - 1 : pageNo)}>
        <><img className='normal' src={projectImages.paginationdark} alt="left" loading='lazy' style={{
          transform: "rotate(180deg)"
        }} />
        <img className='hover' src={projectImages.paginationArrowRightLight} alt="left" loading='lazy' style={{
          transform: "rotate(180deg)"
        }} />
        <TypoGraphy variant='Desktop/Body 1/R | 16 |120' text='Previous' tagName='a' /></>
      </div>}
      {numbers.map((item: number, index: number) => <div className={index + 1 === active ? "pagination_item_active" : "pagination_item"} key={`pagination_last_item_${item}`} onClick={() => handlePageChange(item)}>
        <TypoGraphy variant='Desktop/Body 1/R | 16 |120' text={(index + 1).toString()} tagName='a' styles={isMobile ? {
        fontSize: "14px !important",
        fontStyle: "normal !important",
        fontWeight: "500 !important",
        lineHeight: "150% !important "
      } : {}} /> </div>)}
      {isMobile ? <div onClick={() => handlePageChange(pageNo < pageCount ? pageNo + 1 : pageCount)}> {getPaginationBackImage()} </div> : <div className={pageNo === numbers.length ? "disabled_button" : "next_button pagination_b"} onClick={() => handlePageChange(pageNo < pageCount ? pageNo + 1 : pageCount)}>
        <> <TypoGraphy variant='Desktop/Body 1/R | 16 |120' text='Next' tagName='a' />
        <img className='normal' src={projectImages.paginationdark} alt="left" loading='lazy' />
        <img className='hover' src={projectImages.paginationArrowRightLight} alt="right" loading='lazy' /></>
      </div>}
    </div>;
};
export default Pagination;